import breadcrumbComp from "../../common/breadcrumb-comp";
import AddFavourite from "../../utility/js/addFav.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import Utility from "../../../shared/utility";
import usbService from "../js/usb-services.js";
import html2pdf from "html2pdf.js";
export default {
  data() {
    return {
      actionList: [],
      mainPage: "",
      favouriteList: [],
      pageUrl: "",
      subPage: "",
      showAdd: false,
      subPageUrl: "",
      backSlash: true,
      refresh: true,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      usbLPNText: "",
      usbLPNQuantity: "",
      usbLPNNum: "",
      totalRecords: 0,
      usbConfigData: [],
      csvName: "",
      selectedCountry: "0",
      countryData: [],
      lpnData: [],
      queueType: "C",
      usbLPNStatus: false,
      disablePDFExport: false,
      disableExcelExport: false,
      disableCSVExport: false,
      searchBtnData: [],
      allBtnData: [],
      workstationBtnData: [],
      printerBtnData: [],
      dropOffLPNDialog: false,
      userAssignedLPN: "",
      stagingLocationLPN: "",
      usbSource: "",
      startStopSourcing: "",
      masterConfigQueueData: [],
      lpnKey: "",
      lineKeys: [],
      masterConfigQueueObj: {
        userid: 0,
        country: "",
        workflowcode: "",
      },
      configQueueObj: {
        userid: 0,
        country: "",
        workflowcode: "",
        SearchStr: "",
      },
      headerUSBConfig: [
        { text: "Workflow", value: "workflow", class: "primary customwhite--text" },
        { text: "Status", value: "status", class: "primary customwhite--text" },
        { text: "RLP Order", value: "sono", class: "primary customwhite--text" },
        { text: "Task ID", value: "taskid", class: "primary customwhite--text" },
        { text: "Part Number", value: "part_num", class: "primary customwhite--text" },
        { text: "Location", value: "sh_country", class: "primary customwhite--text" },
        { text: "Sourcing Requested", value: "relativetime", class: "primary customwhite--text" },
        { text: "Progress", value: "progress", class: "primary customwhite--text" },
        { text: "Actions", value: "action", class: "primary customwhite--text" },
      ],
      json_fields: {
        Workflow: "HireDate",
        Status: "status",
        "RLP Order": "sono",
        "Task ID": "taskid",
        "Part Number": "part_num",
        Location: "sh_country",
        "Sourcing Requested": "relativetime",
        Progress: "progress",
      },
      labels_json: {
        HireDate: { title: "Workflow" },
        status: { title: "Status" },
        sono: { title: "RLP Order" },
        taskid: { title: "Task ID" },
        part_num: { title: "Part Number" },
        sh_country: { title: "Location" },
        relativetime: { title: "Sourcing Requested" },
        progress: { title: "Progress" },
      },
      exportDialog: false,
      export50kData: false,
      excelName: "",
      max50Rule: [(v) => (v || "").length <= 50 || "Max Length of 50 character", (v) => !!v || "Field is required"],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.sourceCountryList();
    this.sourcingLPNStatus();
    this.sourceMasterConfigQueueData();
    this.sourceConfigQueueData();
        this.interval = setInterval(() => {
      this.resetFunction();
    }, 60000);
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.usbLPNText = "";
      this.usbLPNQuantity = "";
      this.usbLPNNum = "";
      this.totalRecords = 0;
      this.usbConfigData = [];
      this.csvName = "";
      this.selectedCountry = "0";
      this.countryData = [];
      this.lpnData = [];
      this.queueType = "C";
      this.usbLPNStatus = false;
      this.disablePDFExport = false;
      this.disableExcelExport = false;
      this.disableCSVExport = false;
      this.searchBtnData = [];
      this.allBtnData = [];
      this.workstationBtnData = [];
      this.printerBtnData = [];
      this.usbSource = "";
      this.startStopSourcing = "";
      this.masterConfigQueueData = [];
      this.lpnKey = "";
      this.lineKeys = [];
      this.masterConfigQueueObj = {
        userid: 0,
        country: "",
        workflowcode: "",
      };
      this.configQueueObj = {
        userid: 0,
        country: "",
        workflowcode: "",
        SearchStr: "",
      };
      this.exportDialog = false;
      this.export50kData = false;
      this.excelName = "";
      this.sourceCountryList();
      this.sourcingLPNStatus();
      this.sourceMasterConfigQueueData();
      this.sourceConfigQueueData();
    },
    //Country List
    async sourceCountryList() {
      this.queueType = "C";
      let data = await usbService.sourceCountryList("get", this.userId, this.queueType);
      if (data.message !== "NA") {
        this.countryData = data;
      }
    },
    //LPN Status
    async sourcingLPNStatus() {
      let data = await usbService.sourcingLPNStatus("get", this.userId);
      if (data.message !== "NA") {
        this.lpnData = data;
        this.usbLPNDrop = "";
        if (this.lpnData[0].LPN !== "") {
          this.dropUSBLPN = true;
          this.usbLPNDrop = this.lpnData[0].LPN;
          this.usbLPNStatus = true;
          this.usbLPNText = this.lpnData[0].LPN;
          this.usbLPNQuantity = this.lpnData[0].lpn_qty;
          this.usbLPNNum = this.lpnData[0].LPN;
        } else {
          this.dropUSBLPN = false;
          this.usbLPNDrop = "";
          this.usbLPNStatus = true;
          this.usbLPNText = "NO LPNS ASSIGNED";
          this.usbLPNQuantity = 0;
          this.usbLPNNum = "";
        }
      }
    },
    //Master Configuration Queue Data
    async sourceMasterConfigQueueData() {
      this.masterConfigQueueObj = {
        userid: parseInt(this.userId),
        country: "",
        workflowcode: "",
      };
      let data = await usbService.sourceMasterConfigQueueData("post", this.masterConfigQueueObj);
      if (data.message !== "NA") {
        this.masterConfigQueueData = data;
        const distinctMap = new Map();
        this.masterConfigQueueData.Result1.forEach((item) => {
          const key = JSON.stringify(item);
          if (!distinctMap.has(key)) {
            distinctMap.set(key, item);
          }
        });
        this.searchBtnData = Array.from(distinctMap.values());
        this.allBtnData = this.searchBtnData.filter((item) => item.WorkFlowCode == "ALL");
        this.workstationBtnData = this.searchBtnData.filter((item) => item.WorkFlowCode == "WS");
        this.printerBtnData = this.searchBtnData.filter((item) => item.WorkFlowCode == "PRNT");
      }
    },
    //Configuration Queue Data
    async sourceConfigQueueData(WorkFlowCode) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.configQueueObj = {
        userid: parseInt(this.userId),
        country: this.selectedCountry,
        workflowcode: WorkFlowCode !== undefined ? WorkFlowCode : "",
        SearchStr: this.usbSource,
      };
      this.axios
        .post("/usb/sourcing_configuration_queue", this.configQueueObj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let responseData = response.data.body;
            if (responseData.length !== 0) {
              const newArr = responseData.map((obj) => {
                return {
                  ...obj,
                  relativetime: Utility.displayDateFormat(obj.relativetime),
                };
              });
              this.usbConfigData = newArr;
              this.totalRecords = this.usbConfigData.length;
              this.disablePDFExport = false;
              this.disableExcelExport = false;
              this.disableCSVExport = false;
              if (this.usbConfigData.length == 1 && this.usbConfigData[0].isdisabled == false) {
                this.sourceWorkflow(this.usbConfigData[0]);
              }
            } else {
              this.usbConfigData = [];
              this.totalRecords = 0;
              this.disablePDFExport = true;
              this.disableExcelExport = true;
              this.disableCSVExport = true;
              let Alert = {
                type: "error",
                isShow: true,
                message: "No data based on criteria",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          this.totalRecords = 0;
          this.disablePDFExport = true;
          this.disableExcelExport = true;
          this.disableCSVExport = true;
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Close drop off LPN dialog
    closeDropLPNDialog() {
      this.userAssignedLPN = "";
      this.$refs.stagingLocationCheckForm.resetValidation();
      this.dropOffLPNDialog = false;
    },
    //Drop Off LPN
    usbLPNDropOff() {
      if (this.$refs.stagingLocationCheckForm.validate()) {
        this.lpnDropOffInit();
      }
    },
    //Drop Off process starts
    lpnDropOffInit() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        user_id: parseInt(this.userId),
        method: 1,
      };
      this.axios
        .post("mm/putaway_lpn_pick_dropoff_init", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let responseData = JSON.parse(response.data.body.message);
            this.lpnKey = responseData.comment.replace(/-/g, "");
            this.lpnDropOffValStageLoc();
          } else {
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    lpnDropOffValStageLoc() {
      let obj = {
        user_id: parseInt(this.userId),
        bin: this.stagingLocationLPN,
        method: 1,
      };
      this.axios
        .post("mm/putaway_lpn_pick_dropoff_val_stage_loc", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.lpnDropOffEntire();
          } else {
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    lpnDropOffEntire() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        user_id: parseInt(this.userId),
        bin: this.stagingLocationLPN,
        pick4ship: 0,
        reason_key: 0,
        fromsourcing: 1,
      };
      this.axios
        .post("mm/putaway_lpn_pick_dropoff_entire", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.getSourceConfigLineKeys();
            this.closeDropLPNDialog();
            this.resetFunction();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Get Source Configuration Line Keys
    getSourceConfigLineKeys() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.axios
        .get("usb/sourcing_configuration_line_keys?userid=" + this.userId + "&lpn_key=" + this.lpnKey)
        .then((response) => {
          if (response.status == 200) {
            let responseData = JSON.parse(response.data.body.message);
            this.lineKeys = responseData;
            this.getSourceConfigBTOPrint();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Get Source Configuration BTO Print
    getSourceConfigBTOPrint() {
      for (let i = 0; i < this.lineKeys.length; i++) {
        if (this.lineKeys[i]?.sot_line_key !== undefined) {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.axios
            .get("usb/sourcing_configuration_kits_bto_print_html?user_id=" + this.userId + "&line_id=" + this.lineKeys[i]?.sot_line_key)
            .then((response) => {
              if (response.status == 200) {
                Utility.printZPLPDF(response.data.body.message, EncryptUtility.localStorageDecrypt("defaultName"));
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                var Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              var Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        }
      }
    },
    //On click of Drop LPN from breadcrumb
    onClickUSBDropLPN() {
      this.userAssignedLPN = this.usbLPNDrop;
      this.dropOffLPNDialog = true;
    },
    //CSV Export functionality
    csvFileName() {
      this.csvName =
        "USB_Source_For_Configuration_" + new Date().toISOString().replace("T", "_").replace("Z", "").replace(".", "").replaceAll("-", "_");
    },
    async exportData() {
      this.export50kData = true;
      this.exportDialog = false;
    },
    // to export the Execel file
    async exportExcel() {
      if (this.totalRecords <= 15000) {
        this.startDownload();
        this.export50kData = false;
        this.excelName =
          "USB_Source_For_Configuration_" +
          new Date().toISOString().replace("T", "_").replace("Z", "").replace(".", "").replaceAll("-", "_") +
          ".xls";
        this.finishDownload();
        return this.usbConfigData;
      } else {
        this.exportDialog = true;
        this.finishDownload();
        return true;
      }
    },
    //Export pdf
    printRecords() {
      this.startDownload();
      let response = [];
      response = this.buildHtmlTable(this.logList);
      this.pdfName =
        "USB_Source_For_Configuration_" + new Date().toISOString().replace("T", "_").replace("Z", "").replace(".", "").replaceAll("-", "_") + ".pdf";
      html2pdf(response, {
        margin: 0.5,
        filename: this.pdfName,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 190, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
      });
      this.finishDownload();
    },
    buildHtmlTable(response) {
      this.tblTag = document.createElement("table");
      this.trTag = document.createElement("tr");
      this.thTag = document.createElement("th");
      this.tdTag = document.createElement("td");
      let table = this.tblTag.cloneNode(false);
      table.setAttribute("cellpadding", "0");
      table.setAttribute("cellspacing", "0");
      table.style.border = "1px solid black";
      table.style.borderRight = "none";
      table.style.borderTop = "none";
      let columns = this.addAllColumnHeaders(response, table);
      columns = columns.filter((column) => column !== "tid");
      for (var i = 0, maxi = response.length; i < maxi; ++i) {
        var tr = this.trTag.cloneNode(false);
        for (var j = 0, maxj = columns.length; j < maxj; ++j) {
          var td = this.tdTag.cloneNode(false);
          td.style.border = "1px solid black";
          td.style.padding = "10px";
          td.style.borderLeft = "none";
          td.style.borderBottom = "none";
          var cellValue = response[i][columns[j]];
          td.appendChild(document.createTextNode(cellValue || ""));
          tr.appendChild(td);
        }
        table.appendChild(tr);
      }
      return table;
    },
    addAllColumnHeaders(response, table) {
      let columnSet = [];
      let tr = this.trTag.cloneNode(false);
      for (var i = 0, l = response.length; i < l; i++) {
        for (var key in response[i]) {
          if (columnSet.indexOf(key) === -1) {
            if (key != "tid") {
              columnSet.push(key);
              var th = this.thTag.cloneNode(false);
              th.style.border = "1px solid black";
              th.setAttribute("padding", "5px");
              th.style.borderLeft = "none";
              th.style.borderBottom = "none";
              th.style.backgroundColor = "#005ba8";
              th.style.color = "white";
              if (key == "HireDate") key = "Workflow";
              if (key == "status") key = "Status";
              if (key == "sono") key = "RLP Order";
              if (key == "taskid") key = "Task ID";
              if (key == "part_num") key = "Part Number";
              if (key == "sh_country") key = "Location";
              if (key == "relativetime") key = "Sourcing Requested";
              if (key == "progress") key = "Progress";
              th.appendChild(document.createTextNode(key));
              tr.appendChild(th);
            }
          }
        }
      }
      table.appendChild(tr);
      return columnSet;
    },
    //Source Workflow
    sourceWorkflow(item) {
      if (item.cansource == "2") {
        this.startStopSourcing = "start";
      } else {
        this.startStopSourcing = "stop";
      }
      this.$router.push({
        name: "usbSourceConfigurationDetails",
        params: {
          lineId: btoa(item.line_id.toString()),
          workflowCode: btoa(item.WorkFlowCode.toString()),
          startSourcing: btoa(this.startStopSourcing.toString()),
        },
      });
    },
    //Start the Loader when excel process starts
    startDownload() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    // end the Loader when the process is completed
    finishDownload() {
      let LoaderDialog = {
        visible: false,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    //Add or remove Favourite
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
